module.exports = __webpack_public_path__ + "img/super_blink.51748293.png";